import {TableModalV3} from "../../../helpers/modals/ClassBased/TableModalV3";

// noinspection JSUnusedGlobalSymbols -- Imported via d.ts file
class PickExistingContractorModal extends TableModalV3 {
	/** @var {ContractorsDefs.Contractor} */
	selectedContractor;

	init() {
		// Init select button
		this.modalContainer.querySelectorAll('.pick-contractor-button').forEach(button => {
			button.addEventListener('click', () => {
				this.selectedContractor = JSON.parse(button.dataset.contractor);
				this.notifySuccessListeners(this.selectedContractor);
			})
		})

		super.init();
	}

	/**
	 * @return {ContractorsDefs.Contractor}
	 */
	getSelectedContractor() {
		return this.selectedContractor;
	}
}

export {PickExistingContractorModal}
